import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row-grid" }
const _hoisted_2 = { class: "col-roles" }
const _hoisted_3 = { class: "col-signals" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Divider = _resolveComponent("Divider")
  const _component_ContactTile = _resolveComponent("ContactTile")
  const _component_RolesViewer = _resolveComponent("RolesViewer")
  const _component_PulseNum = _resolveComponent("PulseNum")
  const _component_Icon = _resolveComponent("Icon")
  const _component_TrackerSelect = _resolveComponent("TrackerSelect")
  const _component_TrackerDelete = _resolveComponent("TrackerDelete")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row-container pointer", {hover: $props.hover}])
  }, [
    _createVNode(_component_Divider, {
      m: "0",
      class: "center"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ContactTile, {
        class: "col-company",
        avatar: $props.contact.avatar_url,
        "first-name": $props.contact.first_name,
        "last-name": $props.contact.last_name,
        position: $props.contact.position
      }, null, 8 /* PROPS */, ["avatar", "first-name", "last-name", "position"]),
      _createElementVNode("div", _hoisted_2, [
        ($props.contact.tracker_roles?.length)
          ? (_openBlock(), _createBlock(_component_RolesViewer, {
              key: 0,
              roles: $props.contact.tracker_roles,
              "visible-count": $options.roles_count
            }, null, 8 /* PROPS */, ["roles", "visible-count"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PulseNum, {
          count: $props.contact.signals,
          max: 100,
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($props.contact.signals && _ctx.$dispatch('set-entity', $props.contact.shared_contact_id)), ["stop"]))
        }, null, 8 /* PROPS */, ["count"])
      ]),
      _createElementVNode("div", {
        class: "col-actions",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_component_TrackerSelect, { options: $data.TRACKER_OPTS }, {
          default: _withCtx(({visible}) => [
            _createElementVNode("div", {
              class: _normalizeClass(["icon-button pointer", {hover: visible}])
            }, [
              _createVNode(_component_Icon, {
                icon: "ellipsis-01",
                size: "1.6rem",
                fill: "var(--brand-400)"
              })
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["options"])
      ])
    ]),
    _createVNode(_component_TrackerDelete, {
      ref: "delete",
      onDeleted: $options.onDeleted
    }, null, 8 /* PROPS */, ["onDeleted"])
  ], 2 /* CLASS */))
}